var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-cart d-flex align-items-center justify-content-center"},[_c('img',{attrs:{"src":require('@/assets/images/ibbil/cart/empty-cart.svg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }